import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import * as Icon from 'react-bootstrap-icons';

export default function Header() {
  return (
    <div className='head h-20'>
        <div className='container'>
            <Navbar expand='lg'>
                <Navbar.Brand href='/' className='text-white brand-text fs-1 pe-4'>Anne's</Navbar.Brand>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <Nav className='me-auto navigation'>
                        <Nav.Link href='/' className='pe-4'>Home</Nav.Link>
                        <Nav.Link href='shop' className='pe-4'>Shop</Nav.Link>
                        <Nav.Link href='#about-us' className='pe-4'>About Us</Nav.Link>
                        <Nav.Link href='#contact-us'>Contact Us</Nav.Link>
                    </Nav>
                    <Navbar.Collapse className='justify-content-end'>
                         <Nav className='navigation'>
                        <Nav.Link href='#' className='pe-4'><Icon.Search size={20} /></Nav.Link>
                        <Nav.Link href='#' className='pe-4'><Icon.Cart2 size={20} /></Nav.Link>
                        <button type='button' className='btn login'>Log In</button>
                    </Nav>
                    </Navbar.Collapse>
                </Navbar.Collapse>
            </Navbar>
        </div>
    </div>
  );
}